/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetFormFieldsModel } from './PetFormFieldsModel';
import {
    PetFormFieldsModelFromJSON,
    PetFormFieldsModelFromJSONTyped,
    PetFormFieldsModelToJSON,
} from './PetFormFieldsModel';

/**
 * 
 * @export
 * @interface PetFormSectionModel
 */
export interface PetFormSectionModel {
    /**
     * 
     * @type {string}
     * @memberof PetFormSectionModel
     */
    heading: string;
    /**
     * 
     * @type {string}
     * @memberof PetFormSectionModel
     */
    icon: PetFormSectionModelIconEnum;
    /**
     * this is meant to control the order the section is displayed on the client
     * @type {number}
     * @memberof PetFormSectionModel
     */
    order: number;
    /**
     * 
     * @type {Array<PetFormFieldsModel>}
     * @memberof PetFormSectionModel
     */
    formFields: Array<PetFormFieldsModel>;
}


/**
 * @export
 */
export const PetFormSectionModelIconEnum = {
    Heart: 'heart'
} as const;
export type PetFormSectionModelIconEnum = typeof PetFormSectionModelIconEnum[keyof typeof PetFormSectionModelIconEnum];


/**
 * Check if a given object implements the PetFormSectionModel interface.
 */
export function instanceOfPetFormSectionModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "heading" in value;
    isInstance = isInstance && "icon" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "formFields" in value;

    return isInstance;
}

export function PetFormSectionModelFromJSON(json: any): PetFormSectionModel {
    return PetFormSectionModelFromJSONTyped(json, false);
}

export function PetFormSectionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormSectionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'heading': json['heading'],
        'icon': json['icon'],
        'order': json['order'],
        'formFields': ((json['formFields'] as Array<any>).map(PetFormFieldsModelFromJSON)),
    };
}

export function PetFormSectionModelToJSON(value?: PetFormSectionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'heading': value.heading,
        'icon': value.icon,
        'order': value.order,
        'formFields': ((value.formFields as Array<any>).map(PetFormFieldsModelToJSON)),
    };
}

